import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { deactiveUserDetails } from "../../actions/user";
const DeactiveUser = ({
  auth: { isAuthenticated, user, users, loading },
  getalluser,
  deactiveUserDetails,
  onDeactiveModalChange,
}) => {
  const [formData, setFormData] = useState({
    tenantdeactivereason: "",
    isSubmitted: false,
  });

  const { tenantdeactivereason } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: getalluser ? getalluser._id : "",
      userStatus: "Deactive",
      userDeactiveReason: tenantdeactivereason,
      userDeactiveById: user && user._id,
      userDeactiveByName: user && user.userName,
    };
    deactiveUserDetails(finalData);
    onDeactiveModalChange(true);
  };
  return !isAuthenticated || !user || !users ? (
    <Fragment></Fragment>
  ) : (
    <Fragment>
      <div className="col-lg-12 col-md-9 col-sm-9 col-12 ">
        <form className="row" onSubmit={(e) => onSubmit(e)}>
          <div className="row col-lg-12 col-md-9 col-sm-9 col-12 ">
            <div className="col-lg-12 col-md-4 col-sm-4 col-12">
              <label>Reason For Deactivation* :</label>
            </div>
            <div className="col-lg-12  col-md-4 col-sm-4 col-12">
              <textarea
                name="tenantdeactivereason"
                id="tenantdeactivereason"
                className="textarea form-control"
                rows="3"
                placeholder="Deactive Reason"
                onChange={(e) => onInputChange(e)}
                style={{ width: "100%" }}
                required
              ></textarea>
            </div>
            <div className="col-lg-12 col-md-4 col-sm-4 col-12 py-2">
              <label>Are You Sure You Want to Deactivate ??</label>
            </div>
            { 
            getalluser.batchCount > 0 ?  
            <label className="" 
                style={{color:"blue"}}>
               * User assigned to any SHG cannot be deactivated.
               </label>
             : 
             <></>
             }
            <div
              className="col-lg-12 col-md-9 col-sm-9 col-12 Savebutton"
              size="lg"
            >
              {loading ? (
                <button
                  className="btn sub_form btn_continue blackbrd Save float-right"
                  disabled >
                  Loading...
                </button>
              ) : (
                getalluser.batchCount <= 0 ?
                <input
                  type="submit"
                  name="Save"
                  value="Submit"
                  className="btn sub_form btn_continue Save float-right"
                />
                :
                <input
                  type="button"
                  disabled
                  name="Save"
                  value="Submit"
                  className="btn sub_form btn_continue Save float-right"
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

DeactiveUser.propTypes = {
  auth: PropTypes.object.isRequired,
  deactiveUserDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  deactiveUserDetails,
})(DeactiveUser);
